import MyTableDot from './tableDot.vue';

MyTableDot.install = function(Vue){
  Vue.component('MyTableDot', MyTableDot);
};

export default MyTableDot;